import { Identity } from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/identity_management_pb";
import { StartRetroShareResponse } from "@safetyculture/s12-apis-connect-web/s12/templates/admin/v1/templates_pb";
import {
  RetroShareProcess,
  RetroShareStatus,
} from "@safetyculture/s12-apis-connect-web/s12/templates/v1/template_retroshare_pb";
import { ListRetroShareResponse } from "@safetyculture/s12-apis-connect-web/s12/templates/v1/templates_pb";
import { GetMediaMetadataResponse } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/media_metadata_pb";
import { HardwareType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/sensors_pb";
import {
  Pagination,
  Role,
  SearchOrgsResponse,
  SearchUsersResponse,
  Subscription,
  User,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { DocumentState } from "constants/index";

export type SearchTableBodyRowUserSearchProps = {
  row: User;
  regionCode: string;
};

export type SearchTableBodyRowOrgSearchProps = {
  row: Role;
  regionCode: string;
};

export type SearchTableBodyRowRetroShareSearchProps = {
  row: RetroShareProcess;
};

export type SearchTableBodyRowSubSearchProps = {
  row: Subscription;
  regionCode: string;
};

export type SearchTableBodyRowMediaSearchProps = {
  row: GetMediaMetadataResponse;
  mediaId: string;
};

export type SearchTableBodyRowIdentitySearchProps = {
  row: Identity;
};

export enum TableSearchCategory {
  UserSearch = 0,
  OrgSearch = 1,
  CreditCardSearch = 2,
  MediaSearch = 3,
  IdentitySearch = 4,
}

export interface SearchDisplayTableProps {
  tableSearchCategory: TableSearchCategory;
  tableHeading: string;
  regionCode: string;
  tableData: User[] | Role[] | Subscription[] | MediaMetadata[] | Identity[];
  paginationValues: Pagination;
  handleResultsPageUpdate: (newOffset: number, regionCode: string) => void;
  totalItems: number;
  isLoading: boolean;
}

export type RegionSearchOrg = {
  orgsSearchResp: SearchOrgsResponse;
  pagination: Pagination;
  isLoading: boolean;
};

export type RegionCodeObject = {
  [key: string]: string;
};

export type RegionSearchUser = {
  usersSearchResp: SearchUsersResponse;
  pagination: Pagination;
  isLoading: boolean;
};

export type RegionSearchDocument = {
  documentRawResponse: string;
  isLoading: boolean;
};

export type SearchRetroShareDocument = {
  retroShareResp: ListRetroShareResponse;
  isLoading: boolean;
};

export type StartRetroShareDocument = {
  retroShareResp: StartRetroShareResponse;
  isLoading: boolean;
};

export type UserSearchQuery = {
  firstName: string;
  lastName: string;
  emailLocal: string;
  emailDomain: string;
  userId: string;
  matchExactEmail: boolean;
};

export type IdentitySearchQuery = {
  identityID: string;
  userID: string;
  emailLocal: string;
  emailDomain: string;
  matchExactEmail: boolean;
};

export type OrgSearchQuery = {
  orgName: string;
  roleId: string;
  sortByMembers: boolean;
};

export type TemplateSearchQuery = {
  orgID: string;
  ownerID: string;
  name: string;
  dateFrom: Date;
  dateTo: Date;
  state: DocumentState;
};

export type GrsSearchQuery = {
  orgID: string;
};

export type CreditCardSearchForm = {
  firstName: string;
  lastName: string;
  lastFourDigits: string;
};

export type DocumentSearchQuery = {
  docId: string;
  docType: string;
  collapsedView: boolean | number;
  revId: string;
  useRevId: boolean;
  includeDeleted: boolean;
};

export type SearchRetroShareQuery = {
  templateId: string;
  orgId: string;
  cursor: string;
  userId: string;
  status: RetroShareStatus;
};

export type StartRetroShareQuery = {
  templateId: string;
  orgId: string;
};

export type SensorSearchQuery = {
  id: string;
  sensorType: HardwareType;
};

export type MediaSearchQuery = {
  input: string;
  ids: string[];
};

export type MediaMetadata = {
  mediaId: string;
  mediaSearchResp: GetMediaMetadataResponse;
};

export type RegionSearchMedia = {
  mediaMetadata: MediaMetadata[];
  pagination: Pagination;
  isLoading: boolean;
};
